import React from 'react';

const SingleBrandItem = ({img_1}) => {
   return (
      <>
         <div className="brand__item-wrapper">
            <div className="brand__item">
               <img src={`assets/img/brand/brand-${img_1}.svg`} height="50" alt=""/>
            </div>
         </div>
      </>
   );
};

export default SingleBrandItem;